import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";

/**
 * A consistent page header with optional action chips/buttons.
 * Keep it lightweight so every page can use it.
 */
export default function PageHeader({ title, subtitle, actions = [] }) {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>

        {actions?.length ? (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {actions.map((a) => (
              <Chip
                key={a.key ?? a.label}
                icon={a.icon}
                label={a.label}
                color={a.color ?? "default"}
                variant={a.variant ?? "outlined"}
                clickable={Boolean(a.onClick)}
                onClick={a.onClick}
              />
            ))}
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}

